<template>
    <base-page>
        <div id="main" class="index" slot="page-content">
            <div id="screen1">
                <div id="top-bar">
                    <Logo></Logo>
                    <topMenu></topMenu>
                </div>
                <ImageSwiper :slide-images="slideImages"></ImageSwiper>
            </div>
            <div id="screen2">
                <div id="screen-shots-title" class="s2-block">
                    <span>FEATURED GAMES</span>
                </div>
                <div id="screen-shots-images">
                    <div
                        v-for="img in screenShotImages"
                        :key="img.link"
                        class="screen-shots-images-item-container"
                    >
                        <imageItem
                            :imgsrc="img.img"
                            :link="img.link"
                            :key="img.img"
                            :title="img.title"
                            classname="screen-shot-item"
                        ></imageItem>
                    </div>
                </div>
                <Footer class="index-footer"></Footer>
            </div>
        </div>
    </base-page>
</template>

<script>
import BasePage from "./sub/BasePage";
import imageItem from "./sub/ImageItem.vue";
import topMenu from "./sub/topMenu.vue";
import ImageSwiper from "./sub/ImageSwiper";
import Logo from "./sub/Logo";
import Footer from "./sub/Footer";

export default {
    name: "homepage",
    components: {
        imageItem,
        topMenu,
        ImageSwiper,
        Logo,
        Footer,
        BasePage
    },
    data: function() {
        return {
            imageItemClass: "screen-shot-item",
            screenShotImages: [
                {
                    img: require("@/assets/images/game_pic1.jpg"),
                    link: "/game/legend.html",
                    title: "Legend Online"
                }
            ],
            slideImages: [
                {
                    img: require("@/assets/images/top_bg1.jpg"),
                    link: "/game/legend.html"
                }
            ]
        };
    }
};
</script>

<style lang="scss">
$s2-bk-img: url("../assets/images/content_bg.jpg");
$f-g-img: url("../assets/images/featured_games.png");
body.app-web {
    .index-footer {
        min-height: 59px !important;
    }
    #screen1 {
        width: 100%;
        height: 600px;
        background-color: #000000;
        position: relative;
    }

    #screen2 {
        width: 100%;
        /*min-height: 945px;*/
        background-image: $s2-bk-img;
        background-repeat: repeat;
        background-position: center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .s2-block {
        border: solid 1px rebeccapurple;
        span {
            display: block;
        }
    }

    #screen-shots-title {
        width: 1200px;
        height: 88px;
        color: #402828;
        font-size: 30px;
        font-weight: bold;
        border: none;
        border-bottom: solid 2px;
        display: flex;
        align-items: flex-end;
        padding-bottom: 5px;
    }

    #screen-shots-images {
        width: 1200px;
        min-height: 360px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: space-between;
    }

    .screen-shots-images-item-container {
        width: 388px;
        height: 309px;
        position: relative;
    }

    .screen-shot-item {
        width: 388px;
        height: 289px;
        margin-top: 20px;
    }

    .screen-shots-images-item-container span {
        position: absolute;
        width: 388px;
        height: 289px;
        top: 20px;
        left: 0;
        display: none;
        background-color: rgba(0, 0, 0, 0.5);
    }

    .screen-shots-images-item-container span div {
        color: #ffffff;
        font-family: AdobeHebrew;
        font-size: 28px;
        position: absolute;
        bottom: 25px;
        width: 388px;
        text-align: center;
    }

    .screen-shots-images-item-container a:hover img {
        transform: scale(1.02);
    }

    .screen-shots-images-item-container a:hover span {
        transform: scale(1.02);
        display: block;
        border: solid 1px #fecc7b;
    }

    #top-bar {
        width: 1200px;
        display: flex;
        justify-content: space-between;
        position: absolute;
        z-index: 9999;
        left: 50%;
        margin-left: -600px;
    }
}
</style>
